export default {
  activateLandingPageTitle: '이벤트',
  activateProductCardTitle: '이벤트',
  activateProductPageTitle: '이벤트 예약하기',
  allProductsLandingPageTitle: '특별한 체험 예약하기',
  apply: '적용',
  buyTickets: '티켓 구매',
  cancel: '취소',
  clear: '지우기',
  clearFilters: '필터 지우기',
  discoverExperiences: '체험 찾기',
  exclusive: '독점',
  experience: '체험',
  experiencePhotoOfListing: '{{listingTitle}}의 체험 사진 {{photoNumber}}',
  experiences: '체험',
  filterExperiences: '체험 필터링',
  hostedBy: '호스트:',
  hostLandingPageTitle: '현지 체험',
  hostProductCardTitle: '현지 체험',
  hostProductPageTitle: '현지 체험 예약하기',
  landingPageTitle: '특별한 체험 예약하기',
  mainLandingPageTitle: '모든 체험',
  more: '더보기',
  noExperiencesFound: '체험을 찾을 수 없습니다',
  noExperiencesFoundFor: '해당 조건에 맞는 체험이 없습니다',
  profileImageOfHost: '{{hostName}}의 프로필 이미지',
  reserve: '예약하기',
  reserveLandingPageTitle: '활동 및 편의 시설',
  reserveProductCardTitle: '활동',
  reserveProductPageTitle: '활동 및 편의 시설 예약하기',
  resultsPageTitle: '체험 및 활동 예약하기',
};
